module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0ZGQzEwNyIgZD0iTTMzIDIyaC05LjRMMzAgNUgxOWwtNiAyMWg4LjZMMTcgNDV6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./assets/images/cloze/flash_on.svg
// module id = 3901
// module chunks = 0